<template>
  <div>
    <Ibox :titulo="'Filtros'">
      <FormGroup
        cols="4"
        label="Sucursal"
        :is_loading=filtro.loading_sucursal>
        <v-select 
          @input="cargarEmpresas()"
          label="desc_sucursal"
          :clearable=false
          v-model="filtro.id_sucursal"
          :reduce="sucursal=>sucursal.id_sucursal"
          :options=options_sucursal>
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Empresa"
        :is_loading=filtro.loading_empresa
        v-show="utils.mostrarFiltroEmpresa()">
        <v-select 
          label="nombre_empresa"
          @input="cargarDatos()"
          :clearable=false
          v-model="filtro.id_empresa"
          :reduce="id_empresa=>id_empresa.id_empresa"
          :options=options_empresa>
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Mostrar">
        <v-select 
          :clearable=false
          v-model="filtro.mostrar"
          :options="[{v:'',label:'Todo'},{v:'C',label:'Carga'},{v:'A',label:'Aprobación'}]"
          :reduce="option=>option.v">
        </v-select>
      </FormGroup>
      <b-col cols="12">
        <b-button v-if="filtro.loading_empresa" style="float:right" variant="primary"><Loading :size="'1'" :text="'Cargando filtros'"/></b-button>
        <b-button v-else variant="primary" style="float:right" v-on:click="cargarDatos()">Cargar</b-button>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Documentos vehiculos'">
      <b-col cols="12">
        <DataTable
          :loading="loading"
          :columns="columns"
          :rows="rows"
          clases="table-bordered table-hover table-condensed nowrap">
          <template slot="table-row" slot-scope="props">
            <span  v-if="props.column.field == 'nombre_empresa'">
              {{ props.formattedRow[props.column.field] }}
            </span>
            <span v-else-if="props.column.field == 'total'">
              <span v-if="filtro.mostrar == '' || filtro.mostrar == 'C'" style="white-space: nowrap;">
                <span v-if="!isFinite(cargaTotal(props.row))">
                  -
                </span>
                <a href="javascript:void(0)" v-on:click="verIndicadores(['P','A','R','V'],props.formattedRow[props.column.field])" v-else>
                  {{ cargaTotal(props.row) }}% Carga
                </a>
              </span>
              <br v-if="filtro.mostrar == ''">
              <span v-if="filtro.mostrar == '' || filtro.mostrar == 'A'" style="white-space: nowrap;" >
                <span v-if="!isFinite(aprobacionTotal(props.row))">
                  -
                </span>
                <a href="javascript:void(0)" v-on:click="verIndicadores(['A'],props.formattedRow[props.column.field])" v-else>
                  {{ aprobacionTotal(props.row) }}% Aprobación
                </a>
              </span>
            </span>
            <span v-else>
              <span v-if="filtro.mostrar == '' || filtro.mostrar == 'C'" style="white-space: nowrap;">
                <span v-if="!isFinite(cargaSucursal(props.row, props.column.field))">
                  -
                </span>
                <a href="javascript:void(0)" v-on:click="verIndicadores(['P','A','R','V'],props.formattedRow[props.column.field])" v-else>
                  {{ cargaSucursal(props.row, props.column.field) }}% Carga
                </a>
              </span>
              <br v-if="filtro.mostrar == ''">
               <span v-if="filtro.mostrar == '' || filtro.mostrar == 'A'" style="white-space: nowrap;">
                 <span v-if="!isFinite(aprobacionSucursal(props.row, props.column.field))">
                  -
                </span>
                <a href="javascript:void(0)" v-on:click="verIndicadores(['A'],props.formattedRow[props.column.field])" v-else>
                  {{ aprobacionSucursal(props.row, props.column.field) }}% Aprobación
                </a>
              </span>
            </span>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {userService, empresaService, vehiculoService, sucursalService} from "@/services";
import { utils } from "@/helpers";

export default {
  data(){
    return {
      utils,
      filtro: {
        mostrar:'',
        id_sucursal:0,
        id_empresa:userService.getUser().id_empresa,
        loading_sucursal:true,
        loading_empresa:true
      },
      loading:true,
      options_empresa:[],
      options_sucursal:[],
      columns:[
        {label: 'Empresa', field: 'nombre_empresa'},
      ],
      rows:[],
    }
  },
  mounted () {
    this.cargarSucursales();
  },
  methods : {
    cargaSucursal(row, columna){
      let cargado = row[columna].doc_cargado;
      let total =  row[columna].total;

      if(total > 0){
        cargado = +cargado + +row['0'].doc_cargado;
        total = +total + +row['0'].total;
      }

      return Math.round(((cargado*100)/(total)*100))/100;
    },
    aprobacionSucursal(row, columna){
      let aprobado = row[columna].doc_aprobado;
      let total =  row[columna].total;

      if(total > 0){
        aprobado = +aprobado + +row['0'].doc_aprobado;
        total = +total + +row['0'].total;
      }

      return Math.round(((aprobado*100)/(total)*100))/100;
    },
    cargaTotal(row){
      let cargado = row.cargado;
      let total = row.total;

      return Math.round(((cargado*100)/(total)*100))/100;
    },
    aprobacionTotal(row){
      let aprobado = row.aprobado;
      let total = row.total;

      return Math.round(((aprobado*100)/(total)*100))/100;
    },
    verIndicadores(estado,row){
      this.$router.push({ name: 'vehiculo/documento/documentos', query: {
        p:utils.je64({ 
          estado: estado, 
          id_empresa: row.id_empresa,
          id_sucursal: row.id_sucursal 
        })
      } 
      });
    },
    cargarSucursales() {
      this.filtro.loading_sucursal = true;

      sucursalService.getSucursal({
        id_cliente: userService.getUser().id_cliente,
        id_perfil: userService.getUser().perfiles,
        id_usuario: userService.getUser().id_usuario,
        habilitado:'S'
      }).then(data => {
        this.options_sucursal = data.data;
        
        this.filtro.id_sucursal = data.data.map(function(element){return element.id_sucursal}).toString();
        if(data.data.length > 1 || data.data.length == 0){
          this.options_sucursal.unshift({id_sucursal:this.filtro.id_sucursal,desc_sucursal:'Todo'});
        }

        this.filtro.loading_sucursal = false;

        this.cargarEmpresas();
      });
    },
    cargarEmpresas() {
      this.filtro.loading_empresa = true;

      empresaService.getEmpresa({
        id_empresa:userService.getUser().id_empresa,
        id_sucursal: this.filtro.id_sucursal,
        habilitado:'S'
      }).then(data => {
        this.options_empresa = data.data;

        if(userService.getUser().id_empresa == 0){
          this.options_empresa.unshift({id_empresa:0,nombre_empresa:'Todo'});
          this.filtro.id_empresa = 0;
        }
        this.filtro.loading_empresa = false;

        this.cargarDatos();
      });
    },
    cargarDatos(){
      this.loading = true;

      vehiculoService.getVehiculoResumenDocumentos({
        id_cliente:userService.getUser().id_cliente,
        id_empresa:this.filtro.id_empresa,
        id_sucursal:this.filtro.id_sucursal
      }).then(respuesta => {
        this.rows = respuesta.data;

        this.columns = [
          {label: 'Empresa', field: 'nombre_empresa'},
          {label:'Total',field:'total'},
          {label:'Sin sucursal',field:'0'}
        ];

        if(respuesta.sucursales.length > 0){
          respuesta.sucursales.forEach((element) => this.columns.push({label:element.desc_sucursal, field: element.id_sucursal}));
        }

        this.loading = false;
      });
    },
  }
}
</script>

<style scoped>
</style>
